// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t0sK","footer":"styles_footer__2Azee","passCodeTooltip":"styles_passCodeTooltip__1XeJB"};